export default __webpack_public_path__ + "static/media/2.9d4ef3d3.png";